import EntityForm from "@/mixins/EntityForm";
import Component, { mixins } from "vue-class-component";

@Component({
  inject: {
    taxonomyService: "taxonomyService",
    languageService: "languageService",
    eventService: "eventService",
  },
})
export default class TagForm extends mixins(EntityForm) {
  model = {};
  platformLanguages = [];
  idTaxonomy = null;

  get elements() {
    return [
      {
        id: "code",
        label: this.translations.labels.tag_form_code,
        type: "text",
        required: true,
        rules: "min:4",
        onAction: this.noSpaces,
      },
      {
        id: "displayOrder",
        label: this.translations.labels.tag_form_displayOrder,
        type: "number",
        rules: "gt:0|lte:255",
        required: true
      },
      {
        id: "localizations",
        type: "localizations",
        header: this.translations.labels.form_localizations,
        languages: this.languages,
        resetColumns: true,
        elements: [
          {
            id: "name",
            label: this.translations.labels.tag_form_name,
            type: "text",
            required: true,
          },
        ],
      },
    ];
  }

  get languages() {
    return this.platformLanguages;
  }

  get helpLink() {
    return this.translations.pageHelp.tag;
  }

  noSpaces(evt) {
    let charCode = evt.charCode;
    if (charCode === 32) evt.preventDefault();
    return true;
  }

  // eslint-disable-next-line no-empty-function
  afterCreate () {
  }

  async created() {
    this.idTaxonomy = this.$route.params.idTaxonomy;
    this.taxonomy = await this.taxonomyService.read(this.idTaxonomy);
    this.platformLanguages = await this.languageService.list();

    this.afterCreate();
  }
}
